import { render } from "./BaseRadioGroup.vue?vue&type=template&id=7b996218&scoped=true"
import script from "./BaseRadioGroup.vue?vue&type=script&lang=ts"
export * from "./BaseRadioGroup.vue?vue&type=script&lang=ts"

import "./BaseRadioGroup.vue?vue&type=style&index=0&id=7b996218&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7b996218"

export default script